export type NavBarState = {
    navList:NavBarInfo[] |[]
    page:number
    nav_bar_detail:string
    pageIndex:number
    surveyPage:number
}



export type NavBarInfo = {
    navBar_id: number|null ,
    name:string | null,
    nav_bar_detail:string
    mui_icon:string |null 
}


export const initNavBarState: NavBarState = {
    navList:[],
    page:4,
    nav_bar_detail:'',
    pageIndex:0,
    surveyPage:0
};
  